import { Field } from "formik";
import * as React from "react";
import { formatCurrency } from "../../../common/helper/helper";
import { IWaMemberShipFormModel, WaFormFieldConstants } from "./Constants";
import { renderOptions } from "./FunctionLib";
import { useWaMembershipFormContext } from "./WaMembershipFormContext";
import { IStepProps } from "./WaMembershipFormStep0";

export const stepOneFields = [WaFormFieldConstants.annualIncome];

const WaMembershipFormStep1: React.FC<IStepProps> = (props: IStepProps) => {
	const formContext = useWaMembershipFormContext();

	const onConcessionChange = (e: any) => {
		if (e.target.checked === false) {
			formContext.setTotalDue(formContext.totalDue + formContext.concessionCardDiscount);
		} else if (e.target.checked === true) {
			formContext.setTotalDue(formContext.totalDue - formContext.concessionCardDiscount);
		}
	};

	const onUnionChange = (setFieldValue: any, values: IWaMemberShipFormModel, e: any) => {
		if (values[WaFormFieldConstants.union] === "" && e.target.value !== "union") {
			formContext.setTotalDue(formContext.totalDue - formContext.unionDiscount);
		} else if (values[WaFormFieldConstants.union] !== "" && e.target.value === "") {
			formContext.setTotalDue(formContext.totalDue + formContext.unionDiscount);
		}
		setFieldValue(WaFormFieldConstants.union, e.target.value);
	};

	const unionList = [{ value: "", text: "No Union" }, ...formContext.unionList];

	return (
		<div className={`donStep1 container`}>
			<div>
				<h1 className={"donFormHeader donOpposite" + formContext.colorTheme}>
					Annual and monthly contributions
				</h1>
				<div className={"formPaymentDescription borderOpposite" + formContext.colorTheme}>
					<p>All members must pay:</p>
					<ul className="formPaymentDescriptionList">
						<li>{`An annual fee of $${formatCurrency(
							formContext.yearlyPaymentAmount / 100
						)}; and,`}</li>
						<li>Additional monthly payments according to your income.</li>
					</ul>
					<p>You must complete both step 1 and step 2.</p>
					<p className="formBold">
						Your initial payment will be taken now, and your monthly payments (if
						applicable) will be taken on the 10th of each month (or closest business
						day).
					</p>
					<p>Subsequent annual fees will be taken early each year.</p>
					{/* <p>
						Please click here for more information on{" "}
						<a className="formLink" href="https://www.walabor.org.au/feestructure">
							WA Labor's membership payment structures.
						</a>
					</p> */}
				</div>
				<div className="formDeductionsTable">
					<div className="formIncomeGrid">Initial Annual Fee:</div>
					<div className="formIncomeGrid formBold">{`$${formatCurrency(
						formContext.yearlyPaymentAmount / 100
					)}`}</div>
					<div className="formIncomeGrid" />
					<div className="formIncomeGrid formBold">Deductions</div>
					<div className="formIncomeGrid" />
					<div className="formIncomeGrid" />
					<div className="formDoubleGrid">
						I hold a valid concession card:{" "}
						<span className="formItallic">{`(deduct $${formatCurrency(
							formContext.concessionCardDiscount / 100
						)})`}</span>
					</div>
					<Field
						component="div"
						name={WaFormFieldConstants.concession}
						className="formDoubleGrid"
					>
						<input
							style={{ cursor: "pointer" }}
							defaultChecked={props.values[WaFormFieldConstants.concession] === true}
							name={WaFormFieldConstants.concession}
							type="checkbox"
							onChange={(e) => onConcessionChange(e)}
						/>
					</Field>
				</div>
				<div className="formDeductionsUnion">
					<div className="formDoubleGrid formDoubleGridUnion">
						Affiliated Union Membership:{" "}
						<span className="formItallic">{`(deduct $${formatCurrency(
							formContext.unionDiscount / 100
						)})`}</span>
					</div>
					<div
						data-tip={`${
							props.errors["union"] && props.touched["union"]
								? props.errors["union"]
								: ""
						}`}
						className="formDoubleGrid formDropDownPadding waFormFieldWrapper"
					>
						<Field
							className={`${
								props.errors["union"] && props.touched["union"]
									? " waFormInputError "
									: ""
							}
                                        ${
											!props.errors["union"] && props.touched["union"]
												? " waFormInputSuccess"
												: ""
										}
										form-control standard-form-group`}
							type="text"
							name={WaFormFieldConstants.union}
							component="select"
							value={props.values[WaFormFieldConstants.union]}
							onChange={(e: any) =>
								onUnionChange(props.setFieldValue, props.values, e)
							}
						>
							{unionList.map(renderOptions)}
						</Field>
					</div>
				</div>
				<p className="formBold">Additional Monthly Payments</p>
				<div
					className={`formIncomeTable ${
						props.errors["annualIncome"] && props.touched["annualIncome"]
							? " waFormInputError"
							: ""
					}`}
				>
					<div className="column1">
						<div className="formIncomeGrid formAnnualIncomeText">
							Select Annual Income:
						</div>
					</div>
					<div
						data-tip={`${
							props.errors["annualIncome"] && props.touched["annualIncome"]
								? props.errors["annualIncome"]
								: ""
						}`}
						className={`column2 waFormFieldGap`}
					>
						<div className="formFieldAnnualIncome">
							<div />
							<div className="formIncomeGrid formBold">Annual Income</div>
						</div>
						<Field name={WaFormFieldConstants.annualIncome} component="div">
							{formContext.monthlyPaymentOptions?.map((paymentOption, i) => {
								return (
									<div key={i} className="formFieldAnnualIncome">
										<input
											defaultChecked={
												props.values[WaFormFieldConstants.annualIncome] ===
												paymentOption.paymentOptionAmount
											}
											name={WaFormFieldConstants.annualIncome}
											type="radio"
											style={{ height: "1rem", margin: "auto 0" }}
											value={paymentOption.paymentOptionAmount}
											className="formRadioTick"
											id={paymentOption.paymentOptionAmount.toString()}
										/>
										<label
											style={{ cursor: "pointer" }}
											className="formIncomeGrid"
											htmlFor={paymentOption.paymentOptionAmount.toString()}
										>
											{paymentOption.paymentOptionDescription}
										</label>
									</div>
								);
							})}
						</Field>
					</div>
					<div className="column3">
						<div className="formIncomeGrid formBold">Monthly Payments</div>
						{formContext.monthlyPaymentOptions?.map((paymentOption, i) => {
							return (
								<div className="formIncomeGrid" key={i}>
									{paymentOption.paymentOptionAmount === 0
										? "No monthly payments"
										: `$${formatCurrency(
												paymentOption.paymentOptionAmount / 100
										  )}`}
								</div>
							);
						})}
					</div>
				</div>
				<div className="formTotalDue">
					Total due:{" "}
					<span className="formBold">{`$${(
						formContext.totalDue / 100
					).toString()}`}</span>
				</div>
			</div>
		</div>
	);
};

export default WaMembershipFormStep1;
